import { Component, OnInit, ViewEncapsulation, TemplateRef } from '@angular/core';
import { BaseModalComponent } from '../../../models/base-modal-component';
import { BsModalService, BsModalRef } from 'ngx-bootstrap/modal';
import * as _ from 'underscore';
import { MessageModalType } from '../../../models/enums';
import { isNullOrUndefined } from '../../../models/utils';

export interface MessageModalData {
    type: MessageModalType;
    message: string;
    title?: string;
    okBtnText?: string;
    secondBtnText?: string;
    cancelBtnText?: string;
    cancelBtnFunc?: () => void;
    containerAutomationId?: string;
    contentTemplate?: TemplateRef<any>;
    disableSaveButton?: boolean;
    closeButtonVisible?: boolean;
    durationCounter?: number;
    customClass?: string;
    isDeleteProject?: boolean;
}

@Component({
    standalone: false,
    selector: 'res-message-modal',
    templateUrl: './message-modal.component.html',
    styleUrls: ['./message-modal.component.scss'],
    encapsulation: ViewEncapsulation.None
})
export class MessageModalComponent extends BaseModalComponent implements OnInit {
    messageTypeIcons = {
        Error: 'fa-exclamation-circle',
        Success: 'fa-check',
        Warning: 'fa-exclamation-triangle',
        Information: 'fa-info',
        ConfirmationInfo: '',
        ConfirmationDelete: 'del'
    };
    modalBodyClasses = {
        'fa-exclamation-circle': 'error',
        'fa-check': 'success',
        'fa-exclamation-triangle': 'warning',
        'fa-info': 'info',
        '': 'info',
        'del': 'delete-confirmation'
    };

    message: string;
    title: string;
    modalAutomationId = 'message-modal';
    modalContainerAutomationId: string;
    modalClass = 'message-modal';

    iconClassName: string;
    modalBodyClass: string;

    okBtnText: string;
    cancelBtnText: string;
    secondBtnText: string;
    cancelAction: () => void;

    contentTemplate: TemplateRef<any>;

    disableSaveButton?: boolean;

    closeButtonVisible? = true;
    durationCounter?: number;
    isMessageWithCounter = false;
    isDeleteProject?: boolean;

    constructor(
        private modalService: BsModalService,
        private messageModalRef: BsModalRef,
    ) {
        super(modalService, messageModalRef);
    }

    ngOnInit(): void {
        if (<MessageModalData>this.modalData) {
            const data = <MessageModalData>this.modalData;
            this.title = data.title || data.type;
            this.message = data.message;
            this.okBtnText = data.okBtnText;
            this.cancelBtnText = data.cancelBtnText || 'Close';
            this.secondBtnText = data.secondBtnText;
            this.cancelAction = data.cancelBtnFunc;
            this.iconClassName = this.getClasses(this.messageTypeIcons, data.type);
            this.modalBodyClass = this.getClasses(this.modalBodyClasses, this.iconClassName);
            if (this.modalBodyClass) {
                this.modalClass += ` ${this.modalBodyClass}`;
            }
            if (data.customClass) {
                this.modalClass += ` ${data.customClass}`;
            }
            if (data.containerAutomationId) {
                this.modalContainerAutomationId = data.containerAutomationId;
            } else {
                this.modalContainerAutomationId = 'message';
            }
            this.contentTemplate = data.contentTemplate;
            this.disableSaveButton = data.disableSaveButton;
            if (!isNullOrUndefined(data.closeButtonVisible)) {
                this.closeButtonVisible = data.closeButtonVisible;
            }
            this.durationCounter = data.durationCounter;
            if (this.durationCounter > 0) {
                this.isMessageWithCounter = true;
                this.startDurationCountDown();
            }

            this.isDeleteProject = data.isDeleteProject;
        }
    }

    getClasses(classes, className): string {
        let allClasses = '';
        allClasses = _.pick(classes, className);
        allClasses = allClasses[Object.keys(allClasses)[0]];
        return allClasses || '';
    }

    isPrimaryButtonEnabled(): boolean {
        return this.disableSaveButton ? !this.disableSaveButton : true;
    }

    closeButton(): void {
        if (this.cancelAction) {
            this.cancelAction();
        } else {
            this.closeModal(false);
        }
    }

    startDurationCountDown(): void {
        const startTime = Date.now();
        const startTxtMessage = this.message + '<b>';
        const endTextMessage = '</b>' + '\nAny unsaved changes will be discarded';
        this.message = startTxtMessage + this.computeMinSecFromNumber(this.durationCounter) + endTextMessage;
        const interval = setInterval(() => {
            const currentTime = Date.now();
            const deltaSeconds = Math.floor((currentTime - startTime) / 1000);
            if (deltaSeconds < this.durationCounter) {
                this.message = startTxtMessage + this.computeMinSecFromNumber(this.durationCounter - deltaSeconds) + endTextMessage;
            } else {
                this.closeModal(false, { sessionExpired: true });
                clearInterval(interval);
            }
        }, 200);
    }

    computeMinSecFromNumber(duration: number): string {
        if (this.durationCounter >= 60) {
            const mins = Math.floor(duration / 60);
            const sec = duration - (60 * mins);
            return mins.toString() + (sec < 10 ? ':0' : ':') + sec.toString();
        }
        return duration < 10 ? ':0' + duration : ':' + duration;
    }
}
